import { baseApi } from 'core/api';

const state = () => ({
    _items: null,
    _parameters: {
        page: 1,
        sortBy: 'updated_at',
        sortOrder: 'desc',
        search: null,
        length: 100,
    },
    _editing: null,
    _deleting: null,
    _loading: false,
});

const getters = {
    notes: (state) => state._items,
    notesEditing: (state) => state._editing,
    notesDeleting: (state) => state._deleting,
    notesParameters: (state) => state._parameters,
};

const actions = {
    createContactsByIdNoteCreate({ contactId, form }) {
        return form.post(`core/contacts/note/${contactId}/create`).then((response) => {
            this._setNoteCreated(response);

            return response;
        });
    },

    updateContactsByIdNote({ id, form }) {
        return form.patch(`core/contacts/note/${id}`).then((response) => {
            this._setNoteUpdated(response);

            return response;
        });
    },

    deleteContactsByIdNote({ id, form }) {
        return form.delete(`core/contacts/note/${id}`).then((response) => {
            this._setNoteDeleted(id);

            return response;
        });
    },

    noteCreated(note) {
        this._setNoteCreated(note);
    },

    noteDeleting(note) {
        this._setNoteDeleting(note);
    },

    noteDeleted({ id }) {
        this._setNoteDeleted(id);
    },

    updateNotes({ data }) {
        return baseApi.post('core/notes', data).then((response) => {
            return response.data;
        });
    },

    updateNotesByIdContactById({ contactId, noteId }) {
        return baseApi.put(`core/notes/contact/${contactId}/${noteId}`).then((response) => {
            return response.data;
        });
    },

    deleteNotesByIdContactById({ contactId, noteId }) {
        return baseApi.delete(`core/notes/contact/${contactId}/${noteId}`).then((response) => {
            return response.data;
        });
    },

    // Private methods
    _setNotesLoading(status) {
        this._loading = status;
    },

    _setNoteCreated(data) {
        if (this._items === null) {
            this._items = [data];
        } else {
            this._items.unshift(data);

            if (this._items.length > this._parameters.length) {
                this._items.pop();
            }
        }
    },

    _setNoteUpdated(data) {
        if (this._items === null) {
            this._items = [data];
        } else {
            this._items = this._items.filter((item) => item.id !== data.id);
            this._items.unshift(data);

            if (this._items.length > this._parameters.length) {
                this._items.pop();
            }
        }
    },

    _setNoteDeleted(id) {
        if (this._items === null) {
            return;
        }

        this._items = this._items.filter((o) => o.id !== id);

        if (this.search.results) {
            this.search.results = this.search.results.filter((o) => o.id !== id);
        }
    },

    _setNotesLoaded(data) {
        this._items = data.data;
    },

    _setNoteEditing(data) {
        this._editing = data;
    },

    _setNoteDeleting(data) {
        this._deleting = data;
    },
};

export default {
    state,
    getters,
    actions,
};
